import { DsChart } from './ds-chart.class';
import { DsChartInterface } from '../interfaces/ds-chart.interface';

export class DsDoughnutChart extends DsChart {
  /**
   * Creates an instance of DsDoughnutChart.
   *
   * @param language the current language
   * @memberof DsDoughnutChart
   */
  constructor(language = 'en') {
    super(language);
    this.chartType = 'doughnut';
  }

  /**
   * Overload of base class function.
   *
   * @param chart the current chart
   */
  public initChart(chart: DsChartInterface) {
    chart.options = this.getMergedOptions(chart.customOptions);
    super.initChart(chart);
  }
}
